import React, { Component } from 'react';
import DashboardMenuComponent from '../components/DashboardMenuComponent';
import TopProcessComponent from '../components/TopProcessComponent';
import TopComponent from '../components/TopComponent';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';

import LogoBcp from '../assets/images/logo_bcp.png';
import LogoBbva from '../assets/images/logo_bbva.png';
import LogoInter from '../assets/images/logo_inter.png';
import LogoScotia from '../assets/images/logo_scotia.png';
import { Tools } from '../utils/tools';
import FormFields from '../services/FormFields';
import { Global } from '../services/Global';

import DownloadIcon from '../assets/images/download.png';
import ApiService from '../services/Api';
import { APIS } from '../services/Config';

import IconoPagoEnlinea1 from '../assets/images/icono-pago-en-linea-inactive.png';
import { SUBMISSION_TYPE } from '../utils/constants';
import { Button, Modal } from 'react-bootstrap';

let _fd = (localStorage.getItem('app_fd')) ? JSON.parse(Tools.decryptrData(localStorage.getItem('app_fd'))) : {};

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class PayMethodPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            program_selected: null,
            fields: (_fd.aditional_data !== null) ? _fd.aditional_data : FormFields.aditional_data,
            next_active: true,
            show_editor: false,
            editor_max_words: 10,
            editor_disable: false,
            tipo_comprobante: [],
            tipo_doc_dj: '',
            formas_pago: [],
            selectionRange: {
                startDate: null,
                endDate: null,
                key: 'selection'
            },
            state_tipo_comprobante: null,
            state_forma_pago: null,
            validate_state_tipo_comprobante: null,
            validate_state_forma_pago: null,
            isChecked: false,
            show_dc: false,
            accept_dc: false
        }
    }

    componentDidMount() {
        let _root = this;
        if (!_root.props.glo.isLogin) { window.location.href = '/'; }
        else {
            _root.setState({
                program_selected: JSON.parse(Tools.decryptrData(localStorage.getItem('app_sp'))),
                accept_dc: _root.props.pro.aceptacionDeclaracionJurada,
                validate_state_tipo_comprobante: true,
                validate_state_forma_pago: true,
                tipo_doc_dj: _root.showTipoDocumento(_root.props.pro.tipoDocPostulante)
            }, () => {
                if (_root.props.pro.aceptacionDeclaracionJurada) {
                    _root.setState({
                        isChecked: true
                    });
                }
            });

            Tools.showPreloader();
            ApiService.getData(`${APIS.tiposComprobante}`)
                .then(res => {
                    for (let i = 0; i < res.data.length; i++) {
                        if (res.data[i].id === 3) {
                            res.data.splice(i, 1);
                        }
                    }
                    _root.setState({
                        tipo_comprobante: res.data
                    })
                    // this.props.pro.pagoTipoComprobante = res.data;
                    return ApiService.getData(`${APIS.formasPago}`);
                })
                .then(formas => {
                    Tools.hidePreloader();
                    // _root.props.pro.pagoFormaPago = res.data;
                    for (let i = 0; i < formas.data.length; i++) {
                        if (formas.data[i].id === 3) {
                            formas.data.splice(i, 1);
                        }
                    }
                    _root.setState({
                        formas_pago: formas.data
                    }, () => {

                        let _stateProps = { ..._root.props.pro };
                        console.log('_root.props.glo.otherinfo', _root.props.glo.otherinfo);
                        console.log('_stateProps', _stateProps);

                        console.log('_stateProps.pagoTipoComprobante', typeof (_stateProps.pagoTipoComprobante), _stateProps.pagoTipoComprobante);
                        console.log('_stateProps.pagoFormaPago', typeof (_stateProps.pagoFormaPago), _stateProps.pagoFormaPago);
                        if (_stateProps.pagoTipoComprobante === 3) {
                            this.props.pro.pagoTipoComprobante = -1;
                            _root.setState({
                                validate_state_tipo_comprobante: false,
                            });
                        }
                        if (_stateProps.pagoFormaPago === 3) {
                            this.props.pro.pagoFormaPago = -1;
                            _root.setState({
                                validate_state_forma_pago: false,
                            });
                        }

                        // _root.props.pro.pagoTipoComprobante = (_stateProps.pagoTipoComprobante != null) ? _stateProps.pagoTipoComprobante : _root.props.glo.otherinfo?.tipoDocumentoEmitir;
                        // _root.props.pro.pagoFormaPago = (_stateProps.pagoFormaPago != null) ? _stateProps.pagoFormaPago : _root.props.glo.otherinfo?.formaPago || '';

                        // if (_stateProps.pagoTipoComprobante == null || _stateProps.pagoTipoComprobante === '' || _stateProps.pagoTipoComprobante === 3) {
                        //     _root.props.pro.pagoTipoComprobante = _root.props.glo.otherinfo?.tipoDocumentoEmitir;
                        // }


                        // if (document.getElementById('tipoComprobante')) { document.getElementById('tipoComprobante').value = (_root.props.pro.pagoTipoComprobante?.toString()); }
                        // if (document.getElementById('formaPago')) { document.getElementById('formaPago').value = _root.props.pro.pagoFormaPago?.toString(); }
                        _root.props.process(_root.props.pro);
                    });
                })
                .catch(err => {
                    Tools.hidePreloader();
                    console.log(err);
                });
        }
    }






    onChangeSelect = (e) => {
        let _target = e.target;
        let _root = this;
        console.log(_target.value, typeof (_target.value));
        if (_target.name === 'tipoComprobante') {
            if (_target.value == -1) {
                this.props.pro.pagoTipoComprobante = -1;
                _root.setState({
                    validate_state_tipo_comprobante: false,
                });
            } else {
                this.props.pro.pagoTipoComprobante = parseInt(_target.value);
                _root.setState({
                    validate_state_tipo_comprobante: true,
                });
            }
        }

        if (_target.name === 'formaPago') {
            if (_target.value == -1) {
                _root.props.pro.pagoFormaPago = -1;
                _root.setState({
                    validate_state_forma_pago: false,
                });
            } else {
                _root.props.pro.pagoFormaPago = parseInt(_target.value);
                _root.setState({
                    validate_state_forma_pago: true,
                });
            }

        }

    }

    onChangeCheckDeclaracionJurada = (e) => {
        // e.preventDefault();
        let _target = e.target;
        let _root = this;

        if (_target.name === 'declaracion_j_e') {
            _root.setState({
                isChecked: !_root.isChecked,
                show_dc: _target.checked
            });
        }
        else if (_target.name === 'declaracion_accept') {
            _root.props.pro.aceptacionDeclaracionJurada = _target.checked;
            _root.setState({
                accept_dc: _target.checked
            });

        }
    }

    hideDC = (e) => {
        // e.preventDefault();
        let _root = this;

        if (_root.state.accept_dc) {
            _root.setState({
                show_dc: false
            });
        }
        else {
            _root.setState({
                show_dc: false,
                isChecked: false
            });
        }
    }

    showTipoDocumento = (id_doc) => {
        // console.log(id_doc);
        switch ((id_doc).toString()) {
            case '1':
                return 'DNI';
            case '2':
                return 'CARNE EXT.';
            case '3':
                return 'RUC';
            case '4':
                return 'PASAPORTE';
            case '5':
                return 'PART. NAC.';
            case '6':
                return 'TARJETA DE PROXIMIDAD';
            case '7':
                return 'PART. NAC.';
            case '80':
                return '';
            default:
                return '';
        }

    }

    downloadPDF = (e) => {
        // var url = 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf';
        // fetch(url, {
        //     method: "GET",
        //     responseType: 'blob',
        // }).then(response => {
        // 	console.log(response);
        // 	const url = window.URL.createObjectURL(new Blob([response.data]));
        // 	const link = document.createElement("a");
        // 	link.href = url;
        // 	link.setAttribute("download", "DeclaracionJurada.pdf");
        // 	document.body.appendChild(link);
        // 	link.click();
        // });
    }

    onDownloadFile = (e) => {
        e.preventDefault();

        Tools.showPreloader();
        ApiService.getDataFile(`${APIS.pdfddjj}${this.props.pro.idSubmission}`)
            .then((res) => {
                const blob = new Blob(
                    [res.data],
                    { type: 'application/pdf' }
                );

                const url = window.URL.createObjectURL(blob);
                Tools.hidePreloader();
                window.open(url);
            })
            .catch((err) => {
                console.log(err);
                Tools.hidePreloader();
            });
    }

    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;
        _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/forma-pago'));
        //_root.props.pro.pagoFormaPago = _root.props.pro.pagoFormaPago;

        Tools.showPreloader();
        ApiService.postData(`${APIS.submission}`, _root.props.pro)
            .then(res => {
                Tools.hidePreloader();
                _root.props.process(_root.props.pro);
                _root.props.general(_root.props.glo);
                _root.props.navigate('/documentacion');
            })
            .catch(err => {
                Tools.hidePreloader();
                console.log(err);
            });

    }

    onGoPagoEnLinea = (e) => {
        let _root = this;
        e.preventDefault();
        Tools.showPreloader();
        ApiService.getUrlPagoEnLinea({ "nidtype": "01", "nid": _root.props.pro.nroDocumento, "birthdate": _root.props.pro.fechaNacimiento })
            .then((res) => {
                Tools.hidePreloader();
                if (res.data.success)
                    window.open(res.data.data);
                else {
                    console.log(res.data);
                    Tools.showToaster('warning', '', res.data.message);
                }
            })
            .catch((err) => {
                console.log(err);
                Tools.hidePreloader();
            });

    }

    render() {

        const {
            program_selected,
            tipo_comprobante,
            tipo_doc_dj,
            formas_pago,
            isChecked,
            show_dc,
            accept_dc,
            validate_state_tipo_comprobante,
            validate_state_forma_pago,
        } = this.state;

        const {
            pro,
            navigate
        } = this.props;

        return (
            <>
                <div className="container">
                    <div className="row app-layout-main">
                        <div id="sidebar-dashboard" className="col-md-3 left-side-dashboard">
                            {(program_selected !== null) ? <DashboardMenuComponent navigate={navigate} step={'4'} form={program_selected.form} /> : <></>}
                        </div>
                        <div className="col-md-9 right-side-dashboard">
                            <TopProcessComponent porcent="80" />
                            <div className="row content-dashboard">
                                <div className="col-sm-12">
                                    <div className="row pt-3 pb-3">
                                        <div className="col-sm-12 col-md-6">
                                            <TopComponent direction="back" label="Paso Previo" path={
                                                (pro.idSubmissionType === SUBMISSION_TYPE.TYPE_MAES) ?
                                                    (this.props.pro.tipoPrograma === "SEG") ? '/datos-generales':
                                                        '/carta-presentacion' :
                                                        '/informacion-laboral'
                                                } />
                                        </div>
                                        <div className="col-sm-12 col-md-6"></div>
                                    </div>


                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-6">
                                            <p><small>Para completar tu proceso de inscripción debes hacer el abono del costo de inscripción y adjuntar el comprobante en el siguiente paso de este proceso.</small></p>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <h5><strong>Forma de pago</strong></h5>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-6">
                                            <p><small>Puedes hacer el pago de Inscripción desde la banca por internet o si deseas puedes acercarte a cualquiera de los siguientes bancos.</small></p>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-5 "><img style={{ marginLeft: 9 }} src={LogoInter} width="100%" alt='' /></div>
                                                <div className="col-sm-12 col-md-5"><img style={{ marginLeft: 9 }} src={LogoScotia} width="100%" alt='' /></div>
                                            </div>
                                            <div className="row pt-4">
                                                <div className="col-sm-12 col-md-5"><img style={{ marginLeft: 9 }} src={LogoBcp} width="100%" alt='' /></div>
                                                <div className="col-sm-12 col-md-5"><img style={{ marginLeft: 9 }} src={LogoBbva} width="100%" alt='' /></div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="row pt-3 pb-2">
                                        <h5><strong>Forma de pago en Línea </strong></h5>
                                        <div className="col-sm-12 col-md-6 pt-1">
                                            <small>
                                                También puedes hacer el pago de inscripción desde el Portal de pago en línea haciendo click en el botón correspondiente.
                                            </small>
                                        </div>
                                        <div className="col-sm-12 col-md-5">
                                            <button type="button" className={'btn btn-primary btn-style-5 btn-fin'} onClick={this.onGoPagoEnLinea}>
                                                <img className="icon" src={IconoPagoEnlinea1} alt='' />
                                                <img className="icon-active" src={IconoPagoEnlinea1} alt='' />
                                                Pago en Línea EPG</button>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">

                                    </div>
                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-9">
                                            <p><small>Estos son algunos datos importantes que debes completar y conocer:</small></p>
                                        </div>
                                        <div className="col-sm-12 col-md-8">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-5">
                                                    <div className="form-group pb-2">
                                                        <label htmlFor="distrito" className="pb-2">Tipo de Comprobante a emitir <span className="text-danger">*</span></label>
                                                        <select className="form-control" id="tipoComprobante" name="tipoComprobante" value={this.props.pro.pagoTipoComprobante} onChange={this.onChangeSelect}>
                                                            <option value={-1}>Selecciona una opción</option>
                                                            {
                                                                tipo_comprobante.map((item, i) => (
                                                                    <option key={item.id} value={item.id}>{item.nombre}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <div className="invalid-feedback">
                                                            {(validate_state_tipo_comprobante === false) ?
                                                                <span>Seleccione un tipo de comprobante</span>
                                                                : <></>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-5 offset-md-2">
                                                    <div className="form-group pb-2">
                                                        <label htmlFor="distrito" className="pb-2">Forma de pago del Programa <span className="text-danger">*</span></label>
                                                        <select className="form-control" id="formaPago" name="formaPago" value={this.props.pro.pagoFormaPago} onChange={this.onChangeSelect}>
                                                            <option value={-1}>Selecciona una opción</option>
                                                            {
                                                                formas_pago.map((item, i) => (
                                                                    <option key={item.id} value={item.id}>{item.nombre}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <div className="invalid-feedback">
                                                            {(validate_state_forma_pago === false) ?
                                                                <span>Seleccione una forma de pago</span>
                                                                : <></>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-9">
                                            <p className="italic"><small>*Una vez seleccionado el tipo de comprobante, no se podrá realizar el cambio de documento a emitir.</small></p>
                                            <p className="italic"><small>**Para Emisión de facturas el pago debe realizarse antes de la fecha de vencimiento a la siguiente Cuenta Corriente del banco BCP a nombre de la Universidad Tecnológica del Perú SAC 193-2304436-030 (CCI-002-193-002304436-0-30-15).</small></p>
                                            <p className="italic"><small>***En el caso de Maestrías, Programas de Especialización y Cursos de Especialización, si el alumno acumula 3 cuotas vencidas, se pierde el derecho del beneficio otorgado.</small></p>
                                            <p className="italic"><small>****El costo de inscripción es único y no se ecuentra sujeto a devolución bajo ningún concepto.</small></p>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-6">
                                            <div className="form-check pb-2">
                                                <input className="form-check-input" type="checkbox" value="" id="declaracion_j_e" name="declaracion_j_e" onChange={this.onChangeCheckDeclaracionJurada} checked={isChecked} />
                                                <label className="form-check-label" htmlFor="declaracion_j_e">Declaración Jurada del Estudiante <span className="text-danger">*</span></label>
                                            </div>
                                            <Button className="btn btn-primary btn-style-7 position-relative" onClick={this.onDownloadFile}>
                                                Descargar Declaración Jurada <img className="icon" src={DownloadIcon} alt='' />
                                            </Button>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <small className="text-danger">*Obligatorio</small>
                                        </div>
                                        <div className="col-sm-12 col-md-4"></div>
                                        <div className="col-sm-12 col-md-4" style={{ textAlign: 'right' }}>
                                            <button
                                                className={(accept_dc === true && validate_state_tipo_comprobante === true && validate_state_forma_pago === true) ? 'btn btn-primary btn-style-4' : 'btn btn-primary btn-style-4 disable'}
                                                onClick={this.onClickNext}>
                                                Siguiente paso <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal size="lg" show={show_dc} onHide={this.hideDC}>
                    <Modal.Header closeButton>
                        {/* <Modal.Title>Modal title</Modal.Title> */}
                    </Modal.Header>

                    <Modal.Body>
                        <h5 className="text-center pb-5"><strong>Declaración Jurada del Estudiante</strong></h5>
                        <p><small>Yo, <span className='azul'>{this.props.pro.nombres + " " + this.props.pro.apellidoPaterno + " " + this.props.pro.apellidoMaterno}</span> debidamente identificado con <span className='azul'>{tipo_doc_dj + " " + this.props.pro.nroDocumento}</span> confirmo que la información consignada en la sección Datos Personales es cierta y declaro haber leído en su totalidad el presente documento, aceptando liberar a UTP de cualquier reclamo derivado de la presente autorización.</small></p>
                        <p><small> Conforme la Ley No. 29733 y su reglamento, mediante el llenado y/o forma de la ficha, autorizo de forma expresa y por tiempo indefinido que mis Datos Personales("Datos") sean almacenados sistemáticamente y utilizados por la Universidad Tecnológica del Perú S.A.C. ("UTP")
                            con domicilio en Jr. Natalio Sánchez 125, Lima, para fines estadísticos, administrativos y de gestión comercial, incluyendo pero sin estar limitado a: invitaciones a cursos, talleres, charlas y otros eventos que UTP organice, auspicie o participe. Los datos
                            serán conservados en un banco de datos cuyo titular es la UTP, declaro conocer que para ejercer mis derechos como acceso, rectificación, cancelación y oposición sobre mis Datos puedo dirigirme al correo electrónico arco@utp.edu.pe
                        </small></p>
                        <p>
                            <small><b>Nota:</b></small><br />
                            <small> El costo de inscripción es único y no se encuentra sujeto a devolución bajo ningun concepto.</small>
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="form-check pb-2">
                                        <input className="form-check-input" type="checkbox" value="" id="declaracion_accept" name="declaracion_accept" onChange={this.onChangeCheckDeclaracionJurada} />
                                        <label className="form-check-label" htmlFor="declaracion_accept">Acepto la  Declaración Jurada del Estudiante</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6">
                                    <a className="btn btn-primary btn-style-7" onClick={this.onDownloadFile} href={() => ''} target="noreferrer">Descargar Declaración Jurada
                                        <img className="icon" src={DownloadIcon} alt='' /></a>
                                </div>
                                <div className="col-sm-12 col-md-6 text-right ml-3">
                                    <button
                                        className={(accept_dc) ? 'btn btn-primary btn-style-1 w-50' : 'btn btn-primary btn-style-1 w-50 disable'}
                                        onClick={this.hideDC}>
                                        Continuar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PayMethodPage);